(function () {
	'use strict';
	
	angular.module('smb-app')
		.factory('smbContentSearchDataStore', ['$q', 'smbContentSearchService', ContentSearchDataStore]);
	
	/**
	 * @ngdoc service
	 * @name smb-app.smbContentTypesDataStore
	 * 
	 * @description
	 * Manages the state for the content types configuration.
	 */
	function ContentSearchDataStore($q, smbContentSearchService) {
		var _groupId;
		var _typeId;
		var _tagValues = [];

		var _documents = null;

		return {
			/**
			 * @ngdoc property
			 * @name smbContentTypesDataStore.contentTypes
			 * @propertyOf smb-app.smbContentTypesDataStore
			 * 
			 * @description
			 * All content types that belong to the current content type group.
			 */
			get documents() {
				return _documents;
			},

			/**
			 * @ngdoc method
			 * @name smbContentTypesDataStore.getDocuments
			 * @methodOf smb-app.smbContentTypesDataStore
			 * 
			 * @description
			 * Loads and returns all content types for a specific content type group by group id.
			 * 
			 * @param {Number} groupId The content type group id
			 * 
			 * @returns {Deferred} A promise that resolves to a collection of content types.
			 */
			getDocuments: getDocuments,

			getContentTypeGroupSearchResults: getContentTypeGroupSearchResults,
			
			setTagValues: setTagValues
		};	

		function getDocuments(groupId, typeId) {
			return smbContentSearchService.getDocuments(groupId, typeId, _tagValues)
					.then(function (types) {
						_documents = types.map(function(doc) {
							var d;
							d = doc;
							var index = doc.DocumentAutoName ? doc.DocumentAutoName.indexOf('&&_AirBase_') : -1;
							if (index !== -1) {
								d.DocumentAutoName = doc.DocumentAutoName.substring(0, index > 0 ? index - 5 : 0);
							}
							var contentStatus = doc.StatusInformation.filter(function(tt) {
								return (tt.TagTypeName.match(/&&_AirBase_Content_Status/));
							});
							var todoStatus = doc.StatusInformation.filter(function(tt) {
								return (tt.TagTypeName.match(/&&_AirBase_ToDo_Status/));
							});
							if (contentStatus != null && contentStatus.length > 0 && contentStatus[0].Tags[0].length > 0) {
								d.Status = contentStatus[0].Tags[0];
							}
							else if (todoStatus != null && todoStatus.length > 0 && todoStatus[0].Tags[0].length > 0) {
								d.Status = todoStatus[0].Tags[0];
							}
							else {
								d.Status = '';
							}
							return d;
						});
						return types;
					});
		}

		function getContentTypeGroupSearchResults(groupId) {
			return smbContentSearchService.getContentTypeGroupSearchResults(groupId, _tagValues)
					.then(function (types) {
						_documents = types.map(function(doc) {
							var d;
							d = doc;
							var index = doc.DocumentAutoName ? doc.DocumentAutoName.indexOf('&&_AirBase_') : -1;
							if (index !== -1) {
								d.DocumentAutoName = doc.DocumentAutoName.substring(0, index > 0 ? index - 5 : 0);
							}						
							var contentStatus = doc.StatusInformation.filter(function(tt) {
								return (tt.TagTypeName.match(/&&_AirBase_Content_Status/));
							});
							var todoStatus = doc.StatusInformation.filter(function(tt) {
								return (tt.TagTypeName.match(/&&_AirBase_ToDo_Status/));
							});
							if (contentStatus != null && contentStatus.length > 0 && contentStatus[0].Tags[0].length > 0) {
								d.Status = contentStatus[0].Tags[0];
							}
							else if (todoStatus != null && todoStatus.length > 0 && todoStatus[0].Tags[0].length > 0) {
								d.Status = todoStatus[0].Tags[0];
							}
							else {
								d.Status = '';
							}
							return d;
						});
						return types;
					});
		}

		function setTagValues(tagValues) {
			_tagValues = tagValues
			.filter(function filterTags(t) {
					if (t.indexValue) {
						return t;
					}
				})
				.map(function mapSearchTags(tag) {
				var mappedTag = {};
				mappedTag.TagTypeId = tag.TagTypeId;
				if (tag.DataTypeName === 'Date')
				{
					var date = tag.indexValue;

					var mm = date.getMonth() + 1;
					if (mm < 10)
					{
						mm = '0' + mm;
					}
					
					var dd = date.getDate();
					if (dd < 10)
					{
						dd = '0' + dd;
					}

					mappedTag.Value = [mm, dd, date.getFullYear()].join('');
				}
				else
				{
					mappedTag.Value = tag.indexValue;
				}
				return mappedTag;
			});
		}
		
	}
}());


//////////////////
// WEBPACK FOOTER
// ./app/dataStores/contentSearchDataStore.js
// module id = 112
// module chunks = 1